
import { Button } from "@/components/ui/button";
import { Filter, BarChart } from "lucide-react";
import { Category } from '@/hooks/useCategories';

interface CategoryFiltersProps {
  categories: Category[];
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
}

const CategoryFilters = ({ 
  categories, 
  selectedCategory, 
  setSelectedCategory 
}: CategoryFiltersProps) => {
  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      <div className="text-nation-blue dark:text-blue-300 flex items-center mr-2">
        <Filter size={18} className="mr-1" />
        <span>Filter:</span>
      </div>
      
      <Button 
        key="all"
        variant={!selectedCategory ? "default" : "outline"}
        size="sm"
        className={!selectedCategory 
          ? "bg-nation-purple hover:bg-nation-purple-dark flex items-center gap-2" 
          : "border-gray-300 text-gray-700 flex items-center gap-2"}
        onClick={() => setSelectedCategory(null)}
      >
        <BarChart size={16} />
        All
      </Button>
      
      {categories.map(category => {
        const IconComponent = category.icon || BarChart;
        return (
          <Button 
            key={category.id}
            variant={selectedCategory === category.id ? "default" : "outline"}
            size="sm"
            className={selectedCategory === category.id 
              ? "bg-nation-purple hover:bg-nation-purple-dark flex items-center gap-2" 
              : "border-gray-300 text-gray-700 flex items-center gap-2"}
            onClick={() => setSelectedCategory(category.id)}
          >
            <IconComponent size={16} />
            {category.name}
          </Button>
        )
      })}
    </div>
  );
};

export default CategoryFilters;
